import React, { Component } from 'react'

// redux
import { connect } from 'react-redux'
import mediaActions from '../../redux/qbmedia/actions'

// subcomponent
import HeadBar from './headbar'
import ListMedias from './list_medias'
import Paginate from './paginate'
import ModalMediaInfo from './modal_media_info'
import ModalConfirmDelete from './modal_confirm_delete'
import { Button, Empty } from 'antd'

class MediaManagementScreen extends Component {
    componentDidMount() {
        this.props.loadListMedias({ page_number: 1, page_size: 24, status: 0 })
        if (this.props.match.params.id) {
            this.props.updateCurrentMedia([this.props.match.params.id])
            this.props.showModalCurrentMediaInfo()
        }
    }

    render() {
        const { height } = this.props

        return (
            <div className="MediaScreen">
                <div className="MainCard" style={{ minHeight: height - 100 }}>
                    <HeadBar />
                    {this.props.medias.length > 0 && <ListMedias />}
                    {this.props.medias.length === 0 && (
                        <Empty
                            description={<span>Không có dữ liệu</span>}
                        ></Empty>
                    )}

                    <Paginate />
                    <ModalMediaInfo />
                    <ModalConfirmDelete />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.app,
        medias: state.qbmedia.medias,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadListMedias: params => {
            dispatch(mediaActions.action.loadListMedias(params))
        },
        showModalCurrentMediaInfo: () => {
            dispatch(mediaActions.action.showModalCurrentMediaInfo())
        },
        updateCurrentMedia: media => {
            dispatch(mediaActions.action.updateCurrentMedia(media))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MediaManagementScreen)
